@if (!!data) {
  <article
    [class.shadow]="hasShadow"
    [class.ad-card-bordered]="bordered"
    class="ad-card card rounded-3 border overflow-hidden">
    <header
      class="position-relative"
      [class.image-container-disabaled]="disabledPreviewImages"
      (click)="onPreviewImages()">
      <div class="image-container">
        <nz-image
          [imageUrl]="data.imageUrl"
          [imageAlt]="'Обява: ' + data.title">
        </nz-image>
      </div>
      <div class="p-1 position-absolute z-3 top-0 end-0"
           [class.like-button]="!data.userAdLikeId && supportsHover">
        <nz-toggle-ad-like-button
          [adId]="data.adId"
          [disabled]="disabledLikeButton"
          [userAdLikeId]="data.userAdLikeId"
          (onLike)="data.userAdLikeId = $event"
          (onDislike)="data.userAdLikeId = undefined"/>
      </div>
      @if (data.additionalImageIds.length > 1) {
        <small
          class="m-1 py-1 px-2 rounded bg-light text-muted position-absolute bottom-0 end-0 opacity-75">
          <i class="fa-solid fa-camera pe-1"></i>
          {{ data.additionalImageIds.length }}
        </small>
      }
    </header>
    <section class="card-body">
      <div class="mb-2 fw-bold ad-title card-title text-center">
        {{ data.title }}
      </div>
      <div class="m-0 fs-5 text-center text-primary-emphasis">
        @if (data.adType === AdTypeEnum.DirectSale) {
          <i class="fa-solid fa-shopping-cart"></i>
        } @else if (data.adType === AdTypeEnum.Auction) {
          <i class="fa-solid fa-gavel"></i>
        }
        <strong class="ms-2">{{ data.price }} лв.</strong>
      </div>
      @if (data.adType === AdTypeEnum.DirectSale) {
        <small class="text-center text-muted d-block mb-2">обява с фиксирана цена</small>
      } @else if (data.adType === AdTypeEnum.Auction) {
        <small class="text-center text-muted d-block mb-2">обява от вид аукцион</small>
      }
      <a
        type="button"
        class="w-100 btn btn-sm btn-nz-primary"
        [routerLink]="disabledPreview ? null : [appRoutes.root, appRoutes.ad, data.adId]"
        [attr.aria-label]="'Виж повече за ' + data.title">
        <span>Виж повече</span>
      </a>
    </section>
  </article>
}
